import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_FACET_EXECUTE_ETL_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./useGetNotebooks";

export interface FacetExecuteEtlPayload {
  etl?: Record<string, unknown>;
  etl_json?: Record<string, unknown>;
  decimal_places?: number;
  notebook_id?: number;
}

export const useFacetExecuteEtl = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: FacetExecuteEtlPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_FACET_EXECUTE_ETL_PATH,
        payload,
        "Failed to execute ETL"
      );
      return res.data ?? res;
    },
    onSuccess: (_data, variables) => {
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to execute ETL"));
    },
  });
};
